module.exports = __webpack_public_path__ + "img/21178091.b5cd2d8a.png";